import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

import ModalBox from "components/ModalBox";
import Button from "components/Button";
import SearchInput from "components/SearchInput";
import { ICustomer, IUser, IMeta } from "models/.";
import AppActions from "../../screens/app/actions";
import FilterGenerator from "helpers/filter";
import { URLS } from "constants/urlConstants";

import "./CustomerModal.scss";

interface IProps {
  onCloseModal: () => void;
  customers: ICustomer[];
  visible: boolean;
  currentCustomer: any | null;
  getCustomers: (meta?: IMeta) => void;
  userName: string | null;
  user: IUser;
  meta: IMeta;
}

interface IState {
  searchString: string;
}

class CustomerModal extends React.Component<IProps, IState> {
  public constructor(props) {
    super(props);

    this.state = {
      searchString: "",
    };
  }

  public setCustomer = (customer) => {
    const { onCloseModal, user } = this.props;

    localStorage.setItem("customer", JSON.stringify(customer));
    localStorage.setItem("userName", _.get(user, "profile.name", ""));
    onCloseModal();
    window.location.href = URLS.HOME_URL;
  };

  private getCustomers = _.debounce(() => {
    const { searchString } = this.state;
    const Q = new FilterGenerator();
    if (searchString) {
      Q.and("Number", searchString);
      Q.or("Name", searchString);
    }
    this.props.getCustomers({ currentPage: 0, searchString: Q.query });
  }, 500);

  private onSearchInputChange = (e) => {
    const searchString = e.target.value;
    this.setState({ searchString }, this.getCustomers);
  };

  private getMoreCustomers = ({ target }) => {
    const { getCustomers, customers, meta } = this.props;
    const loadMore =
      target.scrollTop + target.clientHeight >= target.scrollHeight &&
      target.scrollHeight !== 0 &&
      (meta.count || 0) > 10 &&
      customers.length < (meta.count || 0);

    if (loadMore) {
      getCustomers({ ...meta, currentPage: meta.currentPage! + 1 });
    }
  };

  public render() {
    const {
      customers,
      visible,
      currentCustomer,
      user,
      userName,
      onCloseModal,
    } = this.props;
    const isUserChanged = userName !== _.get(user, "profile.name");

    return (
      <ModalBox
        visible={visible}
        onCloseModal={() =>
          isUserChanged ? this.setCustomer(customers[0]) : onCloseModal()
        }
      >
        <div className="customer-modal-body">
          <div className="table-header">
            <div className="big-cell">
              <FormattedMessage id="CUSTOMER_NAME" />
            </div>
            <div className="small-cell">
              <FormattedMessage id="NUMBER" />
            </div>
            <div className="small-cell" />
          </div>
          <SearchInput
            placeholder="CUSTOMER_SEARCH"
            onChange={this.onSearchInputChange}
            value={this.state.searchString}
          />
          <div className="table-body" onScroll={this.getMoreCustomers}>
            {customers.map((customer) => (
              <div key={customer.Id} className="table-row">
                <div className="big-cell">{customer.Name}</div>
                <div className="small-cell">{customer.Number}</div>
                <div className="small-cell">
                  <Button
                    kind="primary"
                    onClick={() => this.setCustomer(customer)}
                    disabled={
                      !isUserChanged && currentCustomer.Id === customer.Id
                    }
                  >
                    CHOOSE
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ModalBox>
    );
  }
}

export default connect(
  (state) => ({
    currentCustomer: state.app.currentCustomer,
    userName: state.app.userName,
    user: state.app.user,
    meta: state.app.meta,
  }),
  {
    getCustomers: AppActions.getCustomers,
  }
)(CustomerModal);
